import { compareVersions } from './version';

// Exposure is separate from capability: old binaries must never execute new features.
export function needsRelease105Update(runtimeInfo) {
    const version = runtimeInfo?.appVersion || runtimeInfo?.runtimeVersion || '';
    const platform = window.NATIVE_PLATFORM || runtimeInfo?.platform;
    return Boolean((window.IS_NATIVE_APP || window.ReactNativeWebView)
        && ['android', 'ios'].includes(platform) && /^\d+\.\d+\.\d+(?:[-+].*)?$/.test(version)
        && compareVersions(version, '1.0.5') < 0);
}

export function needsAndroid105Update(runtimeInfo) {
    return (window.NATIVE_PLATFORM || runtimeInfo?.platform) === 'android' && needsRelease105Update(runtimeInfo);
}

export function needsIos105Update(runtimeInfo) {
    return (window.NATIVE_PLATFORM || runtimeInfo?.platform) === 'ios' && needsRelease105Update(runtimeInfo);
}
